import * as React from "react";
import axios from "axios";

import type * as Types from "./EnquiryTypes";

declare var c4kCore: any;

const initialForm: Types.formObject = {
	parentFullName: null,
	email: null,
	contactNumber: null,
	bestTimeToCall: "Anytime",
	additionalQuestions: null,
	children: [
		{
			daysRequiredList: [],
			overnightEvening: false,
			startDate: null,
			childsName: null,
			childsBirthday: null,
		}
	],
	days: [],
	preferredTourTime: "Anytime",
	saveDetails: false,
	recapResult: null,
	additionalFees: false,
	additionalAvailability: false,
	additionalProgram: false,
	additionalOther: false,
	requestATour: false,
	liveTourBookingSlot: null,
	liveTourBookingDuration: 30,
	expressTkn: null,
}

const initialState: Types.State = {
	initialSelection: null,
	requiredSteps: 0,
	currentStep: 0,
	currentFormComponent: "home",
	form: initialForm,
	canSubmit: false,
	loading: false,
	submitSuccess: false,
	createAccountSuccess: false,
	loggedInUser: null,
	submitError: null,
	createAccountError: null,
	model: null,
	activeChildIndex: 0,
	parentErrors: {
		parentFullName: null,
		email: null,
		contactNumber: null,
		bestTimeToCall: null,
		enquiryDetails: null,
	},
	childErrors: [{
		daysRequiredList: null,
		startDate: null,
		childsBirthday: null,
	}],
	tourDayErrors: {
		daysRequired: null,
	},
	liveTourBookingError: null,
	addToCalendarError: null,
	saveErrors: {
		email: null,
		password: null,
		townSuburb: null,
	},
	totalChildren: 1,
	checkingEmail: false,
	liveTourBookingSessionExpired: false,
};

const reducer = (state, action) => {
	const { type, payload } = action;

	switch (type) {

		case "RESET_OPTION":
			return {
				...state,
				initialSelection: null,
				currentStep: 0,
				requiredSteps: 0,
			}

		case "SELECT_OPTION":
			return {
				...state,
				initialSelection: payload,
				currentStep: 1,
				requiredSteps: payload.steps
			}

		case "SET_MODEL":
			return {
				...state,
				model: payload
			}

		case "SET_STEP":
			return {
				...state,
				currentStep: payload
			}

		case "SET_FORM_COMPONENT":
			return {
				...state,
				currentFormComponent: payload
			}

		case "SET_ACTIVE_CHILD":
			return {
				...state,
				activeChildIndex: payload
			}

		case "UPDATE_FORM":
			return {
				...state,
				form: payload
			}

		case "UPDATE_CHILD_ERRORS":
			return {
				...state,
				childErrors: payload
			}

		case "UPDATE_PARENT_ERRORS":
			return {
				...state,
				parentErrors: payload
			}

		case "UPDATE_TOUR_DAY_ERRORS":
			return {
				...state,
				tourDayErrors: payload
			}

		case "ADD_OR_REMOVE_CHILD":
			return {
				...state,
				form: payload.form,
				childErrors: payload.errors,
				totalChildren: payload.total
			}

		case "SET_CAN_SUBMIT":
			return {
				...state,
				canSubmit: payload
			}

		case "TOGGLE_LOADING":
			return {
				...state,
				loading: !state.loading
			}

		case "SET_SUBMIT_SUCCESS":
			return {
				...state,
				submitSuccess: true,
			}

		case "SET_SUBMIT_ERROR":
			return {
				...state,
				submitError: payload
			}

		case "SET_SAVE_ERRORS":
			return {
				...state,
				saveErrors: payload
			}

		case "SET_CHECKING_EMAIL":
			return {
				...state,
				checkingEmail: payload
			}

		case "SET_CREATE_ACCOUNT_SUCCESS":
			return {
				...state,
				createAccountSuccess: payload
			}

		case "SET_CREATE_ACCOUNT_ERROR":
			return {
				...state,
				createAccountError: payload
			}

		case "SET_LIVE_TOUR_BOOKING_ERROR":
			return {
				...state,
				liveTourBookingError: payload
			}

		case "SET_ADD_TO_CALENDAR_ERROR":
			return {
				...state,
				addToCalendarError: payload
			}

		case "SET_LIVE_TOUR_BOOKING_SESSION_EXPIRED":
			return {
				...state,
				liveTourBookingSessionExpired: payload
			}

		case "SET_UPSELL_CENTRES_HTML":
			return {
				...state,
				upSellCentresHtml: payload
			}

		default:
			return state;
	}
};

const EnquiryContext = React.createContext(undefined);

function EnquiryProvider(props) {

	const [state, dispatch] = React.useReducer(reducer, initialState);

	const Exit = (url = null) => {
		// Exit event on initial component uses url from props mot state, passes it in as argument
		TrackAnalyticsEvent("close")
		window.location.href = !!url ? url : state.model.closeUrl
	}

	const GoBack = () => {
		if (state.initialSelection?.id == 4 && state.currentStep == 2 && state.model.skipChildDetails) {
			dispatch({ type: 'SET_STEP', payload: state.currentStep - 2 })
		}
		else {
			dispatch({ type: 'SET_STEP', payload: state.currentStep - 1 })
		}
	}

	const Next = () => {

		//console.log(`Next: ${state.currentFormComponent}, state.currentStep = ${state.currentStep}`)

		if (state.currentFormComponent == "childDetails") {

			let errorIndexs = []
			let clonedChildErrors = state.childErrors

			// loop through children array
			state.form.children.map((inputs, index) => {

				// Clear out the errors before assessing
				clonedChildErrors[index] = {
					daysRequiredList: null,
					childsName: null,
					startDate: null,
					childsBirthday: null,
				}

				// Make sure each child has birthday and start date, and days required selected
				let missingFields = Object.entries(inputs).filter(([key, value]) => {

					if (key == "childsBirthday" && value == null) {
						// Add error
						clonedChildErrors[index].childsBirthday = { message: "Please provide childs birthday" }
						return true;
					}

					if (key == "startDate" && value == null) {
						// Add error
						clonedChildErrors[index].startDate = { message: "Please provide a start date" }
						return true;
					}

					if (key == "daysRequiredList") {
						let items = 0
						for (var item in (value as any)) {
							items++
						}
						if (items == 0) {
							// Add error
							clonedChildErrors[index].daysRequiredList = { message: "Please select care days" }
							return true;
						}
					}

					return false;
				})

				// If we have found errors for this child then add the index to the errorIndexs for auto nav
				if (missingFields.length > 0) {
					errorIndexs.push(index)
				}
			})

			// If we have errors
			if (errorIndexs.length > 0) {
				// Nav to first error index
				dispatch({ type: "UPDATE_CHILD_ERRORS", payload: clonedChildErrors })
				dispatch({ type: "SET_ACTIVE_CHILD", payload: errorIndexs[0] })

			} else {
				dispatch({ type: 'SET_STEP', payload: state.currentStep + 1 })
				ScrollToTop();
			}

		} else if (state.currentFormComponent == "tourDay") {

			let clonedForm = state.form
			let clonedTourDayErrors = state.tourDayErrors;

			// If no days have been selected
			if (clonedForm.days.length == 0) {
				clonedTourDayErrors.daysRequired = { message: "Select day/s you would like to visit" }
			} else {
				clonedTourDayErrors.daysRequired = null
			}

			if (!!clonedTourDayErrors.daysRequired) {
				// If we have errors update the erros object
				dispatch({ type: "UPDATE_TOUR_DAY_ERRORS", payload: clonedTourDayErrors })
			} else {
				// Go to the next step
				dispatch({ type: 'SET_STEP', payload: state.currentStep + 1 })
				ScrollToTop();
			}

		} else if (state.currentFormComponent == "parentDetails") {
			// Get required Inputs
			let inputs = {
				parentFullName: state.form.parentFullName,
				email: state.form.email,
				contactNumber: state.form.contactNumber,
				bestTimeToCall: state.form.bestTimeToCall,
			}

			// Create empty error object
			let clonedErrors = {
				parentFullName: null,
				email: null,
				contactNumber: null,
				bestTimeToCall: null,
			}

			// Check if any inputs are null or invalid
			let nullFields = Object.entries(inputs).filter(([key, value]) => {

				switch (key) {
					case 'parentFullName':
						if (value == null || value == '') {
							clonedErrors[key] = { message: "Please enter your full name" }
							return true
						}
						break;
					case 'email':
						let emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						if (value == null || value == '' || !emailPattern.test(value.toLowerCase())) {
							clonedErrors[key] = { message: "Please enter a valid email address" }
							return true
						}
						break;
					case 'contactNumber':
						let phonePattern = /^[0]([0-9]\s*){9}$/;
						if (value == null || value == '' || !phonePattern.test(value)) {
							clonedErrors[key] = { message: "Please enter a valid phone number" }
							return true
						}
						break;

				}
				return false;
			})

			// Update the error object
			dispatch({ type: "UPDATE_PARENT_ERRORS", payload: clonedErrors })

			// If no errors were found then move to next step
			if (nullFields.length == 0) {
				dispatch({ type: 'SET_STEP', payload: state.currentStep + 1 })
				ScrollToTop();
			}
		} else if (state.currentFormComponent == "generalEnquiry") {

			// Get required Inputs
			let inputs = {
				parentFullName: state.form.parentFullName,
				email: state.form.email,
				contactNumber: state.form.contactNumber,
				bestTimeToCall: state.form.bestTimeToCall,
			}

			// Enquiry detail items
			let enquiryDetails = {
				requestATour: state.form.requestATour,
				additionalFees: state.form.additionalFees,
				additionalAvailability: state.form.additionalAvailability,
				additionalProgram: state.form.additionalProgram,
				additionalOther: state.form.additionalOther,
			}

			// Create empty error object
			let clonedErrors = {
				parentFullName: null,
				email: null,
				contactNumber: null,
				bestTimeToCall: null,
				enquiryDetails: null,
			}

			// Check if any inputs are null or invalid
			let nullFields = Object.entries(inputs).filter(([key, value]) => {

				switch (key) {
					case 'parentFullName':
						if (value == null || value == '') {
							clonedErrors[key] = { message: "Please enter your full name" }
							return true
						}
						break;
					case 'email':
						let emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						if (value == null || value == '' || !emailPattern.test(value.toLowerCase())) {
							clonedErrors[key] = { message: "Please enter a valid email address" }
							return true
						}
						break;
					case 'contactNumber':
						let phonePattern = /^[0]([0-9]\s*){9}$/;
						if (value == null || value == '' || !phonePattern.test(value)) {
							clonedErrors[key] = { message: "Please enter a valid phone number" }
							return true
						}
						break;

				}
				return false;
			})

			// Loop through the enquiry detail items and filter out all true(selected items)
			let selectedEnquiryItems = []
			Object.entries(enquiryDetails).forEach(([key, value]) => {
				value && selectedEnquiryItems.push(key)
			})

			// If we have no enquiry selection
			if (selectedEnquiryItems.length == 0) {
				// Add the error
				clonedErrors.enquiryDetails = { message: "Please select at least one enquiry topic" }
			} else {
				//else check if it is 'Other'
				selectedEnquiryItems.filter((item: any) => {
					if (item == 'additionalOther') {
						// If it is Other then check that the textarea field is not empty
						if (state.form.additionalQuestions == null || state.form.additionalQuestions == "") {
							clonedErrors.enquiryDetails = { message: "Please provide additional information below" }
						}
					}
				})
			}

			// Update the error object
			dispatch({ type: "UPDATE_PARENT_ERRORS", payload: clonedErrors })

			// If no errors were found then move to next step
			if (nullFields.length == 0 && clonedErrors.enquiryDetails == null) {
				dispatch({ type: 'SET_STEP', payload: state.currentStep + 1 })
				ScrollToTop();
			}
		} else if (state.currentFormComponent == "liveTourBooking") {
			if (state.form.liveTourBookingSlot == null) {
				dispatch({ type: "SET_LIVE_TOUR_BOOKING_ERROR", payload: "Live tour booking date and time is required" })
			} else {
				dispatch({ type: 'SET_STEP', payload: state.currentStep + 1 })
			}
			ScrollToTop();
		}
	}

	// ADD A CHILD
	const AddChild = () => {
		let clonedForm = state.form
		clonedForm.children.push({
			daysRequiredList: [],
			overnightEvening: false,
			startDate: null,
			childsName: null,
			childsBirthday: null,
		})
		let clonedChildErrors = state.childErrors
		clonedChildErrors.push({
			daysRequiredList: null,
			startDate: null,
			childsBirthday: null,
		})

		let payload = {
			form: clonedForm,
			errors: clonedChildErrors,
			total: clonedForm.children.length
		}
		dispatch({ type: 'ADD_OR_REMOVE_CHILD', payload: payload })
	}

	// REMOVE A CHILD
	const RemoveChild = () => {
		let clonedForm = state.form
		let clonedChildErrors = state.childErrors
		clonedForm.children.splice(state.activeChildIndex, 1)
		clonedChildErrors.splice(state.activeChildIndex, 1)

		let payload = {
			form: clonedForm,
			errors: clonedChildErrors,
			total: clonedForm.children.length
		}
		dispatch({ type: 'ADD_OR_REMOVE_CHILD', payload: payload })

		// If we removed the latest child push the index back one
		if (state.activeChildIndex == clonedForm.children.length) {
			dispatch({ type: 'SET_ACTIVE_CHILD', payload: state.activeChildIndex - 1 })
		}
	}

	// SET ACTIVE CHILD
	const SetActiveChildIndex = (index) => {
		dispatch({ type: 'SET_ACTIVE_CHILD', payload: index })
	}

	// Select Child Care Day
	const SelectChildDay = (dayId) => {
		let clonedForm = state.form
		let clonedChildErrors = state.childErrors

		if (dayId == null) {
			// This is the overnight/Evening option
			clonedForm.children[state.activeChildIndex].overnightEvening = !clonedForm.children[state.activeChildIndex].overnightEvening
		} else {
			// This was an actual weekday option
			// Is this day in the childs list already??
			if (clonedForm.children[state.activeChildIndex].daysRequiredList.includes(dayId)) {
				// Get index
				let index = clonedForm.children[state.activeChildIndex].daysRequiredList.indexOf(dayId)
				// Remove it
				clonedForm.children[state.activeChildIndex].daysRequiredList.splice(index, 1)
				// Check the daysRequiredList for this index
				if (clonedForm.children[state.activeChildIndex].daysRequiredList.length == 0) {
					// If no required days then update the error message
					clonedChildErrors[state.activeChildIndex].daysRequiredList = { message: "Please select at least one day" }
				}
			} else {
				// Otherwise add it
				clonedForm.children[state.activeChildIndex].daysRequiredList.push(dayId)
				// Check the daysRequiredList for this index
				if (clonedForm.children[state.activeChildIndex].daysRequiredList.length > 0) {
					// If no required days then update the error message
					clonedChildErrors[state.activeChildIndex].daysRequiredList = null
				}
			}
		}

		// Sort the array of days
		if (clonedForm.children[state.activeChildIndex].daysRequiredList.length > 1) {
			clonedForm.children[state.activeChildIndex].daysRequiredList.sort(function (a, b) { return a - b });
		}

		// Update form and Errors
		dispatch({ type: 'UPDATE_FORM', payload: clonedForm })
		dispatch({ type: 'UPDATE_CHILD_ERRORS', payload: clonedChildErrors })

	}

	// PRE SUBMIT
	const SubmitEnquiry = () => {
		dispatch({ type: 'TOGGLE_LOADING' })
		dispatch({ type: 'SET_SUBMIT_ERROR', payload: null })

		let form = state.form

		// If the form has children then format the dates and days
		let formattedChildren = null;

		// Only format children if its request a tour or live tour booking
		if ((state.initialSelection.id == 4 && !state.model.skipChildDetails) && !!form.children && form.children.length > 0) {
			// Need to format all the child data to match back end model
			let children = form.children
			formattedChildren = []

			children.forEach(child => {

				// Decalre blank object to hold the new formatted child info
				let newChildObject: Types.formattedChildObject = {
					name: "",
					birthday: null,
					careStartDate: null,
					selectedCareDays: null,
					overnightCareRequired: null,
				}

				// Populate the object with the formatted child data
				newChildObject.name = child.childsName || ""
				newChildObject.birthday = child.childsBirthday.toISOString().split('T')[0]
				newChildObject.careStartDate = child.startDate.toISOString().split('T')[0]
				newChildObject.selectedCareDays = child.daysRequiredList.map(day => day + 1)
				newChildObject.overnightCareRequired = child.overnightEvening

				formattedChildren.push(newChildObject)

			})
		}

		let visitDays;
		if (!!form.days) {
			visitDays = form.days.map(day => day + 1)
		}

		let additionalQuestionIds = []
		state.form.additionalFees && additionalQuestionIds.push(0)
		state.form.additionalAvailability && additionalQuestionIds.push(1)
		state.form.additionalProgram && additionalQuestionIds.push(2)


		let centreIds = ''
		state.model.enquiryCentreDetailsList.forEach((centre, index) => {
			if (index == 0) {
				centreIds += centre.centreUserIdHash
			} else {
				centreIds += `,${centre.centreUserIdHash}`
			}
		})

		let jsonData = {
			enquiryType: form.requestATour ? 2 : state.initialSelection.id,
			centreUserIdHash: centreIds,
			recaptchaResult: form.recapResult,
			parentFullName: form.parentFullName,
			email: form.email,
			contactNumber: form.contactNumber,
			bestTimeToCall: form.bestTimeToCall,
			bestTimeToVisit: form.preferredTime,
			streetAddress: form.streetAddress,
			suburb: form.townSuburb,
			postcode: form.postCode,
			state: form.state,
			saveDetails: form.saveDetails,
			password: form.password,
			enquiryDetails: form.additionalQuestions,
			selectedVisitDays: visitDays,
			childrenDetails: formattedChildren,
			accessGuidelines: form.accessGuidelines,
			additionalQuestions: additionalQuestionIds,
			liveTourBookingSlot: form.liveTourBookingSlot != null ? form.liveTourBookingSlot.toISO() : null,
			token: state.model.token,
			includeRecommendCentresHtml: true,
			includeUpsellCentresHtml: true,
			centrePostcode: state.model.enquiryCentreDetailsList[0].centrePostcode,
			centreSuburbHashId: state.model.enquiryCentreDetailsList[0].centreSuburbIdHash,
		}

		let url = state.model.enquiryRequestUrl

		SubmitEnquiryRequest(jsonData, url)
	}

	const WaitlistRedirect = () => {
		TrackExternalWaitlistEvent();
		// Blank? New window and closeModal event
		(window as any).open(state.model?.waitListUrl, '_blank').focus();
	}

	const TrackExternalWaitlistEvent = () => {
		let analyticsInfo = GetAnalyticsCategoryAction();
		var el = document.getElementById("enquiryComponent");
		var eventContext = "type=waitlist";
		var waitlistButton = document.getElementById("enquiry-waitlist-cta");

		c4kCore.analyticsTrackEventWithSuburbAndListing(analyticsInfo.eventCategory, analyticsInfo.eventAction, eventContext, el);
		c4kCore.analyticsTrackOutgoingLinkEvent(state.model.ExternalWaitListUrl || "", waitlistButton);
	}

	const GetAnalyticsCategoryAction = (): Types.analyticsInfo => {
		let eventCategory = "Enquiry";
		let eventAction = "Contact";
		if (state.initialSelection?.id == 2) {
			eventAction = "Request a tour";
		} else if (state.initialSelection?.id == 3) {
			eventAction = "Waitlist";
		} else if (state.initialSelection?.id == 4) {
			eventAction = "Live Tour Booking";
		}
		return { eventCategory, eventAction };
	}

	const TrackAnalyticsEvent = (eventType: string, sourceId: string = null) => {
		let analyticsInfo = GetAnalyticsCategoryAction();

		if (sourceId != null) {
			let el = document.getElementById(sourceId);

			if (el == null) {
				return
			}

			let context = c4kCore.getGoogleAnalyticsEventContextForElement(el);
			let eventLabel = `type=${eventType}${(!!context ? `|${context}` : '')}`

			c4kCore.analyticsTrackEventWithSuburbAndListing(analyticsInfo.eventCategory, analyticsInfo.eventAction, eventLabel, el);
		} else {
			var evt = new CustomEvent("trackgaevent", { detail: { eventCategory: analyticsInfo.eventCategory, eventAction: analyticsInfo.eventAction, eventLabel: `type=${eventType}` } });
			window.dispatchEvent(evt);
		}

	}

	const TrackUpsellDisplayAnalyticsEvent = (upsellCentreUserIdHashes: string[]) => {
		const eventCategory = "Enquiry Upsell"
		const eventAction = "Display"

		state.model.enquiryCentreDetailsList.forEach(d => {
			let sourceCentreUserIdHash = d.centreUserIdHash

			const eventLabel = `upsellUserIdHashes=${(upsellCentreUserIdHashes.join(","))}|sourceCentreUserIdHash=${sourceCentreUserIdHash}`

			c4kCore.analyticsTrackEvent(eventCategory, eventAction, eventLabel)
		})
	}

	const ScrollToTop = () => {
		document.querySelector('body').scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		});
	}

	// SUBMIT AJAX
	const SubmitEnquiryRequest = (jsonData, url) => {
		//console.log("submit data:", jsonData)

		let headers = {
			'Content-Type': 'application/json',
		}

		const json = JSON.stringify(jsonData)

		// AXIOS REQUEST
		axios.post(url, json, { headers: headers }).then((response: any) => {
			//console.log(response)
			let data = response.data
			if (data.isSuccess) {
				dispatch({ type: 'TOGGLE_LOADING' })
				dispatch({ type: 'SET_SUBMIT_SUCCESS', payload: true })
				dispatch({ type: 'SET_CAN_SUBMIT', payload: false })

				// Populate Upsell Centres
				if (!!data.upsellCentresHtml && data.upsellCentresHtml != "") {
					// Put temporary token in the form
					let clonedForm = state.form
					clonedForm.expressTkn = data.expressSubmitToken
					dispatch({ type: 'UPDATE_FORM', payload: clonedForm })

					let container = document.getElementById('enquiry-upsell-centres')
					container.innerHTML = data.upsellCentresHtml
					c4kCore.initImageLazyLoading(container)

					let upSellCentreIdHashes = [];
					container.querySelectorAll(".upsell-centre-desktop-card").forEach(e => {
						upSellCentreIdHashes.push(e.getAttribute("data-id"))
					})
					TrackUpsellDisplayAnalyticsEvent(upSellCentreIdHashes)
				}

				// Populate Recommended Centres
				if (!!data.recommendCentresHtml && data.recommendCentresHtml != "") {
					let container = document.getElementById('enquiry-c4k-recommends')
					container.innerHTML = data.recommendCentresHtml
					c4kCore.initImageLazyLoading(container)
					let title = document.querySelector('#recommends-title')
					if (!!title) {
						title.innerHTML = `<div class="text-skin-heading text-2xl mb-4 pt-4 lg:pt-8 px-6 lg:px-0">Other centres in ${state.model.enquiryCentreDetailsList[0].centreSuburb} you might be interested in</div>`
					}
					let viewMoreButton = document.querySelector('#recommends-view-more')
					if (!!viewMoreButton) {
						viewMoreButton.innerHTML = `<div class="text-center pt-12"><a href=${data.recommendCentresViewMoreUrl} class="cta-secondary button inline-block mb-20" target="_blank">View more results</a><div>`
					}
				}

			} else {
				let error = data.errors[0]
				if (error == "Invalid/expired access token") {
					dispatch({
						type: 'SET_LIVE_TOUR_BOOKING_SESSION_EXPIRED',
						payload: true
					})
				} else {
					dispatch({
						type: 'SET_SUBMIT_ERROR',
						payload: {
							message: data.errors[0]
						}
					})
				}
				dispatch({ type: 'TOGGLE_LOADING' })

				ScrollToTop();

				// Reset Recap
				(window as any).grecaptcha.reset();
			}

		})
			.catch(error => {
				// Reset Recap
				(window as any).grecaptcha.reset();

				let errorMessage = {
					message: "Something went wrong please try again"
				}

				dispatch({
					type: 'SET_SUBMIT_ERROR',
					payload: errorMessage
				})
				dispatch({ type: 'TOGGLE_LOADING' })

				ScrollToTop();
			})
			.finally(() => {
				//
			})
	}

	// Send the enquiry to upsell centres that are selected
	const SendEnquiryUpsells = async (queue) => {
		let url = state.model.enquiryRequestUrl
		let successQueue = []
		let errorQueue = []

		let headers = {
			'Content-Type': 'application/json',
		}

		//Do Promise to send enquiry for each centre in the queue
		await Promise.all(queue.map(async (centreId) => {
			let sourceId = `upsell-desktop-${centreId}`
			TrackAnalyticsEvent("submit", sourceId)

			// Get form data
			let form = state.form
			let additionalQuestionIds = []
			state.form.additionalFees && additionalQuestionIds.push(0)
			state.form.additionalAvailability && additionalQuestionIds.push(1)
			state.form.additionalProgram && additionalQuestionIds.push(2)

			// Build the object for the enquiry
			let jsonData = {
				enquiryType: form.requestATour ? 2 : state.initialSelection.id,
				centreUserIdHash: centreId,
				centrePostcode: state.model.centrePostcode,
				parentFullName: form.parentFullName,
				email: form.email,
				contactNumber: form.contactNumber,
				bestTimeToCall: form.bestTimeToCall,
				additionalQuestions: additionalQuestionIds,
				enquiryDetails: form.additionalQuestions,
				token: form.expressTkn
			}

			const json = JSON.stringify(jsonData)

			// Axios call
			await axios.post(url, json, { headers: headers }).then((response: any) => {
				//console.log('UPSELL SEND RESP::', response)
				if (response.data.isSuccess) {
					successQueue.push(centreId)
				} else {
					let centreError = {
						id: centreId,
						message: "Token expired"
					}
					errorQueue.push(centreError)
				}
			})
				.catch(error => {
					console.log(error)
				})
		})).then(async () => {
			var evt = new CustomEvent("upsellcentreresults", { detail: { successQueue: successQueue, errorQueue: errorQueue } });
			window.dispatchEvent(evt);
		})

	}

	return (

		/*Must add any function names to the provider value object*/
		/*You can also customise the values ie name = state.name*/
		/*You will use the keys from this object to unpack the values in components*/
		<EnquiryContext.Provider
			value={{
				state,
				dispatch,
				GoBack,
				Next,
				AddChild,
				SetActiveChildIndex,
				RemoveChild,
				SelectChildDay,
				WaitlistRedirect,
				SubmitEnquiry,
				Exit,
				ScrollToTop,
				TrackAnalyticsEvent,
				SendEnquiryUpsells
			}}>
			{props.children}
		</EnquiryContext.Provider>
	);
}

export { EnquiryContext, EnquiryProvider };